import React from 'react';
import { useTranslation } from 'react-i18next';

import SessionModal, {
  BASE_CLASSNAME,
} from '@/ebat/components/blocks/Scanbat/SessionModals/SessionModal';
import { useScanbatSessionContext } from '@/ebat/contexts/ScanbatSessionContext/ScanbatSessionContext';

const WarningModal = () => {
  const { t } = useTranslation();
  const { isSessionWarning, restartSession } = useScanbatSessionContext();

  return (
    <SessionModal
      className={`${BASE_CLASSNAME}--warning`}
      content={{
        title: t('ebat:entities:scanbat.session_modals.warning.title'),
        body: t('ebat:entities:scanbat.session_modals.warning.body'),
        action: t('ebat:entities:scanbat.session_modals.warning.action'),
      }}
      isOpen={isSessionWarning}
      onActionClick={restartSession}
    />
  );
};

export default WarningModal;
